// AchievementList.js
import React from 'react'
import Achievement from '../common/Achievement'
import {
  getBadgesCount,
  getCompletedBadgesCount,
  getCompletedStagesCount,
  isEarnedCourse,
  isEarnedStage
} from '../../utils/helpers'

const AchievementList = ({ courses, openModal }) => {
  if (!courses.length) return <p className="text-center">Course not found</p>

  return courses.map((course, index) => (
    <div key={index} className="mt-4 px-4">
      <div className="flex justify-between items-center">
        <p className="cursor-pointer text-lg font-bold">{course?.title}</p>
        <p>
          {getCompletedBadgesCount(course)}/{getBadgesCount(course)}
        </p>
      </div>
      <div className="flex flex-wrap gap-4">
        {course?.stages?.length > 0 && course.stages.map((stage) => {
            return stage.badges.map((badge, idx) => (
              <Achievement
                key={idx}
                imageUrl={badge.image_url}
                active={isEarnedStage(stage)}
                onClick={() => isEarnedStage(stage) && openModal(badge)}
              />
            ))
          }
        )}
        {course?.badges?.length > 0 && course.badges.map((badge, idx) => (
          <Achievement
            key={idx}
            imageUrl={badge.image_url}
            active={isEarnedCourse(course)}
            onClick={() => isEarnedCourse(course) && openModal(badge)}
          />
        ))}
      </div>
    </div>
  ))
}

export default AchievementList
